import { Injectable, Inject } from '@angular/core';

export class BaseSearchDO {


	public proposalNum: String = null;
	public baseProductFamilyCd: String = null;
	public sumInsured: String = null;
	public finalPremium: String = null;
	public tripTypeCd: String = null;
	public tripRegionCd: String = null;
	public makeDesc: String = null;
	public modelName: String = null;




}